import { render, staticRenderFns } from "./DetailStatusesStatisticDomain.vue?vue&type=template&id=3d887874"
import script from "./DetailStatusesStatisticDomain.vue?vue&type=script&lang=js"
export * from "./DetailStatusesStatisticDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports